import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

const SegmentCountImpl = ({ resource }: any) => <span>{resource.count}</span>;

export const SegmentCount = connectWithHammock(({ segmentId }) => ({
  endpoint: ENDPOINTS.segmentStats,
  id: segmentId,
}))(SegmentCountImpl);
